<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <!-- 编码 -->
      <el-form-item label="品牌名" prop="name">
        <el-input v-model.trim="form.name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 邮编 -->
      <el-form-item label="排序号" prop="sort">
        <el-input v-model.trim="form.sort" autocomplete="off" placeholder="请输入" @input="handleInput"></el-input>
      </el-form-item>
      <!-- 线路区分 -->
      <el-form-item label="线路" prop="sort">
        <el-select v-model="form.kor_type" placeholder="请选择">
          <el-option v-for="item in options" :key="item.type" :label="item.name" :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    valid
  } from 'mockjs'
  import {
    brandDetail,
    brandUpdate,
    brandAdd,
    Index_country_list
  } from '@/api/xgcApi'

  export default {
    name: 'ManageStore',
    data() {
      return {
        form: {
          kor_type:null,
          name:null,
          sort:null
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
            message: '请输入名称'
          }],
          sort: [{
            required: true,
            trigger: 'blur',
            message: '请输入内容'
          }],
        },
        options:[],
        title: '',
        dialogFormVisible: false,
        isShow: true,
      }
    },
    created() {},
    methods: {
      getBrand(){
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
        })
      },
      handleInput() {
        // Remove non-numeric characters and leading zeros
        this.form.sort = this.form.sort.replace(/\D/g, '').replace(/^0+/, '')
      },
      showEdit(row) {
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
          if (!row) {
            this.title = '添加'
            this.isShow = false
          } else {
            this.isShow = true
            this.title = '编辑'
            // const {
            //   data
            // } = await brandDetail(row.id)
            // this.form = data
            // this.form = Object.assign({}, row)
            brandDetail(row.id).then(req=>{
                this.form = req.data
                // this.form = Object.assign({}, row)
            })
          }
          this.dialogFormVisible = true
        })

      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
        this.$emit('fetch-data')
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            if (this.isShow == false) {
              const {
                msg
              } = await brandAdd(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              this.form = this.$options.data().form
            } else {
              const {
                msg
              } = await brandUpdate(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              // this.form = this.$options.data().form
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>
